import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { EnumData } from '../../../utils/enumData';
import { LABEL_PADDING_LEFT, PADDING_TOP, ROOT_PADDING_LEFT } from './PlexTextField';

export interface PlexSelectProps<T extends string | boolean> {
  className?: string;
  disabled?: boolean;
  label: string;
  handleChange?: (value: T) => void;
  options: EnumData<T>;
  value: T | null | undefined;
}

export function PlexSelect<T extends string | boolean>({
  className,
  disabled,
  label,
  handleChange,
  options,
  value,
}: PlexSelectProps<T>): React.ReactElement {
  const classes = useStyles();
  const allOptions = Object.keys(options);
  const selectedValueList = allOptions.filter((item) => options[item].value === value);
  const selectedValue = selectedValueList.length === 1 ? selectedValueList[0] : '';
  return (
    <FormControl className={classNames(classes.select, className)}>
      <InputLabel id={label} className={classes.label}>
        {label}
      </InputLabel>
      <Select
        aria-label={label}
        disabled={disabled}
        value={selectedValue}
        classes={{
          root: classes.root,
          icon: classes.icon,
        }}
        onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>): void => {
          const value = allOptions.filter((item) => item === event.target.value)[0];
          const v: T = options[value].value;
          handleChange != null && handleChange(v);
        }}
      >
        {Object.keys(options).map((item: string) => (
          <MenuItem key={item} value={item}>
            {options[item].displayName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

const useStyles = makeStyles((theme) => ({
  select: {
    paddingTop: PADDING_TOP,
  },
  label: {
    paddingLeft: LABEL_PADDING_LEFT,
    top: PADDING_TOP,
  },
  root: {
    paddingLeft: ROOT_PADDING_LEFT,
  },
  icon: {
    marginRight: 20,
  },
}));
